import GenericDB from './generic-db'

export default class AccountClientsDB extends GenericDB {
  constructor(accountId) {
    super(`accounts/${accountId}/clients`)
  }

  // Here you can extend AccountClientsDB with custom methods
}
